window.addEventListener('reviews:loaded', (e) => {
  const eventName = e.detail.prodName
  const revTitle = document.querySelector(".reviews-title__product-name")

  if(revTitle && revTitle.textContent.trim() === '') {
    if(eventName) {
      revTitle.textContent = eventName
    } else {
      const pageTitle = document.querySelector(".product__info-wrapper .product__title .heading")
      const pageSubtitle = document.querySelector(".product__info-wrapper .product__title .subheading")
      revTitle.textContent = `${pageTitle.textContent.trim()} ${pageSubtitle.textContent.trim()}`
    }
  }
})
